import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./reducers";
import setAuthToken from "./util/setAuthToken";

const store = configureStore({
  reducer: rootReducer,
  preloadedState: { auth: { token: localStorage.getItem("token") } },
});

store.subscribe(() => {
  if (store.getState().auth.token) {
    setAuthToken(store.getState().auth.token);
    localStorage.setItem("token", store.getState().auth.token);
  } else if (!store.getState().auth.token) {
    setAuthToken();
    localStorage.removeItem("token");
  }
});
if (store.getState().auth.token) {
  setAuthToken(store.getState().auth.token);
} else if (!store.getState().auth.token) {
  setAuthToken();
}
export default store;
